import { useState } from 'react'
import PropTypes from 'prop-types'

import { withLocalize } from 'react-localize-redux'
import { connect } from 'react-redux'
import { Modal } from '@material-ui/core'
import DownloadSettingsForm from '../components/DownloadStatisticsForm'
import { requestFile } from '../../../../utils/request'
import { isSessionLimitError } from 'utils/sessionLimit'
import { showSnackbar } from 'common/actions/snackbar'

import FileSaver from 'file-saver'
import styles from './DownloadStatisticsContainer.module.scss'

const DownloadStatisticsContainer = props => {
  const [open] = useState(true)

  const { hideModal, user, showSnackbar } = props
  const { isPremium, _id, collaborativeInformation } = user.toJS()

  const isManager =
    collaborativeInformation?.length > 0 && collaborativeInformation[0]?.role === 'Manager'

  const handleSubmit = async data => {
    if (props.isSubmitting) return

    const systemId = props.system._id
    const startDate = new Date(data.startDate.toString())
    startDate.setHours(0)
    startDate.setMinutes(0)
    startDate.setSeconds(0)

    const endDate = new Date(data.endDate.toString())
    endDate.setHours(23)
    endDate.setMinutes(59)
    endDate.setSeconds(59)

    const submitData = {
      params: data.params,
      micaname: props.system.name,
      freq: data.freq,
      order: data.order,
      CustomerId: _id,
      DeviceId: systemId
    }
    try {
      const response = await requestFile(
        `systems/statistics/` + startDate.toISOString() + `/` + endDate.toISOString(),
        {
          method: 'POST',
          data: {
            ...submitData
          },
          headers: {
            accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'content-type': 'application/json'
          }
        }
      )
      if (response === 413) throw new Error('File too large')

      const blob = await response.blob()
      FileSaver.saveAs(blob, response.headers.get('filename'))
    } catch (err) {
      // The session listener already tells the user when the session is over.
      if (!isSessionLimitError(err)) showSnackbar('snackbar.whoops')
    }
    hideModal()
  }

  return (
    <Modal
      open={open}
      onClose={hideModal}
      arial-labelledby='simple-modal-title'
      arial-desccribedby='simple-modal-description'
    >
      <div className={styles.content}>
        <DownloadSettingsForm
          {...props}
          isPremium={isPremium}
          onSubmit={handleSubmit}
          isManager={isManager}
        />
      </div>
    </Modal>
  )
}

DownloadStatisticsContainer.propTypes = {
  hideModal: PropTypes.func.isRequired,
  showSnackbar: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  contentText: PropTypes.string,
  title: PropTypes.string,
  buttonName: PropTypes.string
}

const mapActionsToProps = {
  showSnackbar
}

export default withLocalize(connect(null, mapActionsToProps)(DownloadStatisticsContainer))
